import React from 'react';
import './RightsPage.scss';

export const RightsPage: React.FC = () => {
  return (
    <div className="rights">
      <h1 className="rights__title">Rights</h1>

      <p className="rights__message">There is no rights yet &copy;2023</p>
    </div>
  );
};
